import { replaceAll } from 'helpers/replaceAll';

const normalizeText = (text: string): string => {
    return text.replace(/\s+/g, ' ').trim();
};

export const stripHtml = (html: string): string => {
    let newString = html;

    newString = replaceAll(newString, /<script[\s\S]*?<\/script>/gi, ' ');
    newString = replaceAll(newString, /<style[\s\S]*?<\/style>/gi, ' ');
    newString = replaceAll(newString, /<[^>]+>/g, ' ');
    newString = replaceAll(newString, '&amp;nbsp;', ' ');
    newString = replaceAll(newString, '&nbsp;', ' ');
    newString = replaceAll(newString, '&amp;quot;', '"');
    newString = replaceAll(newString, '&amp;', '&');
    newString = replaceAll(newString, '&quot;', '"');
    newString = replaceAll(newString, '&lt;', '<');
    newString = replaceAll(newString, '&gt;', '>');
    newString = replaceAll(newString, '&#39;', "'");
    newString = replaceAll(newString, '\t', ' ');
    newString = replaceAll(newString, /\r\n|\n|\r/g, ' ');

    return normalizeText(newString);
};

function truncateAtWordBoundary(text: string, maxLength: number, isEllipsisRequired: boolean): string {
    if (text.length <= maxLength) {
        return text;
    }

    let end = maxLength;

    if (text.charAt(maxLength) !== ' ') {
        const nextSpace = text.indexOf(' ', maxLength);
        end = nextSpace === -1 ? text.length : nextSpace;
    }

    return text.substring(0, end) + (isEllipsisRequired && end < text.length ? '...' : '');
}

export function substringStripHtml(
    text: string | null,
    maxLength: number | null,
    addEllipsisOnTextOverflow = true,
): string | undefined {
    if (!text) {
        return undefined;
    }

    let newString = text;

    newString = replaceAll(newString, '<li>', ' -'); // change
    newString = replaceAll(newString, '</li>', '');
    newString = replaceAll(newString, '</ul>', ' '); // space after ul
    newString = newString.replace(/(<([^>]+)>)/gi, ''); // remove html
    newString = replaceAll(newString, '\t', ' '); // remove tabs
    newString = replaceAll(newString, '&amp;nbsp;', '&');
    newString = replaceAll(newString, '&amp;quot', '"');
    newString = replaceAll(newString, '&amp;', '&');
    newString = replaceAll(newString, '&nbsp;', ' ');
    newString = newString.replace(/(r\n|\n|\r)/gm, ''); // remove nextlines

    const isEllipsisRequired = maxLength !== null && newString.length > maxLength && addEllipsisOnTextOverflow;

    if (maxLength !== null) {
        return truncateAtWordBoundary(newString, maxLength, isEllipsisRequired);
    }

    return newString;
}
